// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./close_icon_x.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#app div.Header {
  z-index: 32;
  position: relative;
  background-color: #F5F6F9;
  -webkit-box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.12);
          box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.12);
  margin: 0;
  min-height: 62px;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
}
#app div.Header div.navbar {
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  padding: 0;
  width: 100vw;
  height: 72px;
}
#app div.Header div.navbar .closeButton {
  display: inline-block;
  padding: 20px 24px;
  width: 14px;
  height: 32px;
  border-right: solid 1px #E8E9F0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
  background-size: 18px;
  cursor: pointer;
}
#app div.Header div.navbar .heading {
  display: inline-block;
  position: relative;
  bottom: 29px;
  margin-left: 20px;
  color: #002E33;
  font-size: 22px;
}
#app div.Header div.navbar .Button.accept.editor {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right 15px center;
  background-size: 20px;
  margin-bottom: 2px;
  padding-right: 45px !important;
}
#app div.Header div.navbar .Button:not(.DropdownButton) {
  padding-top: 16px !important;
}
#app div.Header div.navbar .buttons {
  margin-right: 20px;
  margin-top: 12px;
  float: right;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
}
#app div.Header div.navbar .buttons > .Button {
  -webkit-box-shadow: 1px 1px 3px 0 #E8E9F0;
          box-shadow: 1px 1px 3px 0 #E8E9F0;
  margin-left: 12px;
  text-align: center;
  height: 48px;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  font-size: 14px;
  white-space: nowrap;
}
#app div.Header div.navbar .buttons > .Button:not(.button-menu-div) {
  padding: 13px 24px;
}
#app div.Header div.navbar .buttons .button-menu-div {
  position: relative;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  vertical-align: middle;
}
#app div.Header div.navbar .buttons .button-menu-div .menu-base {
  padding: 16px 24px;
  position: relative;
  -webkit-box-flex: 0;
  -ms-flex: 0 1 auto;
      flex: 0 1 auto;
}
#app div.Header div.navbar .buttons .button-menu-div .dropdown {
  padding: 14px 20px;
  border-left: 1px solid #E8E9F0;
}
#app div.Header div.navbar .buttons .button-menu-div .button-menu {
  float: left;
  top: 100%;
  min-width: 8.1rem;
  padding: 0;
  border: 0;
}
#app div.Header div.navbar .buttons .button-menu-div .button-menu .Button {
  padding: 14px 35px 14px 24px;
  text-align: left;
}
#app div.Header div.navbar .buttons .button-menu-div .button-menu .Button:not(:first-child) {
  border-top: 1px solid #E8E9F0;
}
#app div.Header div.navbar .buttons .button-menu-div .button-menu:after, #app div.Header div.navbar .buttons .button-menu-div .button-menu:before {
  right: 10px !important;
  left: auto;
  top: -8px;
}
#app div.Header div.navbar.agerasNextMigration {
  width: calc(100vw - 54px);
}`, "",{"version":3,"sources":["webpack://./src/client/components/invoiceEditor/InvoiceEditorHeading/InvoiceEditorHeading.scss","webpack://./src/client/Global/Colors.scss"],"names":[],"mappings":"AAGE;EACE,WAAA;EACA,kBAAA;EACA,yBCoDK;EDnDL,qDAAA;UAAA,6CAAA;EACA,SAAA;EACA,gBAAA;EACA,WAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,4BAAA;EAAA,6BAAA;MAAA,0BAAA;UAAA,sBAAA;EACA,8BAAA;UAAA,sBAAA;AAFJ;AAII;EACE,8BAAA;EAAA,6BAAA;MAAA,uBAAA;UAAA,mBAAA;EACA,yBAAA;MAAA,sBAAA;UAAA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;AAFN;AAIM;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,oEAAA;EACA,qBAAA;EACA,eAAA;AAFR;AAKM;EACE,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,cCpCO;EDqCP,eAAA;AAHR;AAQU;EACE,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;EACA,kBAAA;EACA,8BAAA;AANZ;AASQ;EACE,4BAAA;AAPV;AAWM;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,oBAAA;EAAA,oBAAA;EAAA,aAAA;EACA,uBAAA;MAAA,oBAAA;UAAA,2BAAA;AATR;AAWQ;EACE,yCAAA;UAAA,iCAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,8BAAA;UAAA,sBAAA;EACA,eAAA;EACA,mBAAA;AATV;AAWU;EACE,kBAAA;AATZ;AAaQ;EACE,kBAAA;EACA,2BAAA;EAAA,2BAAA;EAAA,oBAAA;EACA,sBAAA;AAXV;AAaU;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;MAAA,cAAA;AAXZ;AAcU;EACE,kBAAA;EACA,8BAAA;AAZZ;AAeU;EACE,WAAA;EACA,SAAA;EACA,iBAAA;EACA,UAAA;EACA,SAAA;AAbZ;AAeY;EACE,4BAAA;EACA,gBAAA;AAbd;AAcc;EACE,6BAAA;AAZhB;AAeY;EACE,sBAAA;EACA,UAAA;EACA,SAAA;AAbd;AAkBM;EACE,yBAAA;AAhBR","sourcesContent":["@import \"../../../Global/Colors\";\n\n#app {\n  div.Header {\n    z-index: 32;\n    position: relative;\n    background-color: $Gray20;\n    box-shadow: 1px 1px 4px 0 rgba($Black, 0.12);\n    margin: 0;\n    min-height: 62px;\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    box-sizing: border-box;\n\n    div.navbar {\n      flex-direction: row;\n      align-items: center;\n      padding: 0;\n      width: 100vw;\n      height: 72px;\n\n      .closeButton {\n        display: inline-block;\n        padding: 20px 24px;\n        width: 14px;\n        height: 32px;\n        border-right: solid 1px $Gray30;\n        background: url(\"./close_icon_x.svg\") no-repeat center;\n        background-size: 18px;\n        cursor: pointer;\n      }\n\n      .heading {\n        display: inline-block;\n        position: relative;\n        bottom: 29px;\n        margin-left: 20px;\n        color: $DeepSeaGreen;\n        font-size: 22px;\n      }\n\n      .Button {\n        &.accept{\n          &.editor {\n            background-image: url(arrow.svg);\n            background-repeat: no-repeat;\n            background-position: right 15px center;\n            background-size: 20px;\n            margin-bottom: 2px;\n            padding-right: 45px !important;\n          }\n        }\n        &:not(.DropdownButton) {\n          padding-top: 16px !important;\n        }\n      }\n\n      .buttons {\n        margin-right: 20px;\n        margin-top: 12px;\n        float: right;\n        display: flex;\n        justify-content: flex-start;\n\n        > .Button {\n          box-shadow: 1px 1px 3px 0 $Gray30;\n          margin-left: 12px;\n          text-align: center;\n          height: 48px;\n          box-sizing: border-box;\n          font-size: 14px;\n          white-space: nowrap;\n\n          &:not(.button-menu-div) {\n            padding: 13px 24px;\n          }\n        }\n\n        .button-menu-div {\n          position: relative;\n          display: inline-flex;\n          vertical-align: middle;\n\n          .menu-base {\n            padding: 16px 24px;\n            position: relative;\n            -webkit-box-flex: 0;\n            flex: 0 1 auto;\n          }\n\n          .dropdown {\n            padding: 14px 20px;\n            border-left: 1px solid $Gray30;\n          }\n\n          .button-menu {\n            float: left;\n            top: 100%;\n            min-width: 8.1rem;\n            padding: 0;\n            border: 0;\n\n            .Button {\n              padding: 14px 35px 14px 24px;\n              text-align: left;\n              &:not(:first-child) {\n                border-top: 1px solid $Gray30;\n              }\n            }\n            &:after, &:before {\n              right: 10px !important;\n              left: auto;\n              top: -8px;\n            }\n          }\n        }\n      }\n      &.agerasNextMigration {\n        width: calc(100vw - 54px);\n      }\n    }\n  }\n}\n","// Brand\n$ElectricGreen: #01FF94;\n$DeepSeaGreen: #002E33;\n$Lavender: #DBD4FF;\n$DayGrey: #EDF1F7;\n\n// Primary\n$Black: #000;\n$White: #FFF;\n$Green: #00E383;\n$Yellow: #FBDB3F;\n$Red: #D92D20;\n$Purple: #5E46D2;\n\n// Blues\n$Blue140: #131C3E;\n$Blue120: #1E267D;\n$Blue110: #2258CE;\n$Blue90: #5E8BEF;\n$Blue60: #7CA2F8;\n$Blue10: #D0E6FE;\n$Blue5: #E4F1FF;\n\n// Purples\n$Purple140: #5D4DAE;\n$Purple20: #F8F6FF;\n\n// Greens\n$Green140: #075E42;\n$Green120: #078E64;\n$Green110: #29B574;\n$Green90: #32D583;\n$Green60: #6CE9A6;\n$Green20: #BAEFCB;\n$Green10: #DDF3E4;\n$Green5: #E8FFF0;\n\n// Yellows\n$Yellow220: #735714;\n$Yellow200: #8F7638;\n$Yellow120: #DCB11A;\n$Yellow30: #FFF8B8;\n$Yellow10: #FFF9CC;\n\n// Reds\n$Red120: #951307;\n$Red110: #C94337;\n$Red90: #F07B70;\n$Red10: #F7DDD9;\n$Red5: #FFF8F6;\n\n// Grays\n$Gray200: #26282F;\n$Gray90: #697588;\n$Gray60: #A7A9B4;\n$Gray50: #D3D6DF;\n$Gray40: #D9DCE5;\n$Gray30: #E8E9F0;\n$Gray20: #F5F6F9;\n$Gray10: #F6F9FF;\n\n// Legacy color variables: Remove these after deprecating @zervant/reactcomponents package\n$shadowColor: #5F6766;\n$normalTextColor: $Gray200;\n$normalBorderColor: $Gray30;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
